import React, { useEffect, useState } from 'react';
import { ReactSession } from "react-client-session";
import Header from './Header'
import Contenido from './Contenido';
import Login from './Login/Login';
import './css/Sidebar.css'
import ContextGlobal from './Context/ContextGlobal';
import MenuOpciones from './MenuOpciones';
import Localizacion from './Localizacion';



import { useNavigate } from "react-router-dom";



function Principal() {
    const [login, setLogin] = useState(false);
    const [regional, setRegional] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        var tiempoActivo = localStorage.getItem("timeInit");
        if (tiempoActivo == null) {
            localStorage.clear()
            setLogin(false);
        }else{
            var tiempoActual = new Date().getTime();
            if(((tiempoActual-tiempoActivo)/(1000*60*60*24))>=2){
                localStorage.clear()
                setLogin(false);
            }
        }
    }, [])
    useEffect(() => {
         setRegional(ReactSession.get("regional"));

        // REDIRECCIÓN DESPUÉS DEL LOGIN
        const redirect = localStorage.getItem("redirectAfterLogin");
        if (login && redirect) {
            localStorage.removeItem("redirectAfterLogin");
            navigate(redirect, { replace: true });
        }
    }, [login, navigate]);

    if (login) {
        return (
            <ContextGlobal>
                <Header login={login} />
                <Contenido regional={regional} />
                <MenuOpciones setLogin={setLogin} />
            </ContextGlobal>
        );
    } else {
        if (ReactSession.get("idSession") === undefined) {
            return (
                <ContextGlobal>
                    <Header login={login} />
                    <Login setLoginAcceso={setLogin} />
                    {/*<Localizacion/>*/}
                </ContextGlobal>
            );
        } else {
            setLogin(true);
            return null;
        }
    }
}
export default Principal;


